import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IonicModule } from '@ionic/angular';
import { NgxEchartsModule } from 'ngx-echarts';
import { ButtonToggleSelectModule, CalendarPickerModule, CustomSourceSelectorModule, KeyValueBlockModule, SourceSelectorModule, TitleContentComponent } from 'ngx-zcs-components';
import { MatExpansionModule } from '@angular/material/expansion';

import { EvchargeTelemetryComponent } from './evcharge-telemetry.component';
import { ComponentsModule } from '../components/components.module';
import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { DurationPipe } from '../pipes/duration.pipe';
import { DaysDiffPipe } from '../pipes/day-diff.pipe';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    EvchargeTelemetryComponent,
  ],
  imports: [
    BlockTitleComponent,
    ButtonToggleSelectModule,
    CalendarPickerModule,
    CommonModule,
    ComponentsModule,
    CustomSourceSelectorModule,
    DaysDiffPipe,
    DurationPipe,
    IonicModule,
    KeyValueBlockModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    TitleContentComponent,
    // Use full ECharts bundle so tooltip/legend/renderer are available
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
  ],
  exports: [
    EvchargeTelemetryComponent,
  ],
})
export class EvchargeTelemetryModule { }
